"use client";

import { useSearchParams } from "next/navigation";

const styles = new Proxy({"Blog":"Blog-67ac5","Title":"Title-67ac5"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import SearchBar from "@/themes/kinerva-v2/components/Blog/components/SearchBar";
import ErrorMessage from "@/themes/kinerva-v2/components/Blog/components/ErrorMessage";
import ResultsFor from "@/themes/kinerva-v2/components/Blog/components/ResultFor";
import Posts from "@/themes/kinerva-v2/components/Blog/components/Posts";
import Pagination from "@/themes/kinerva-v2/components/Blog/components/Pagination";
import KinervaContact from "@/themes/kinerva-v2/components/KinervaContact";
import { Tag } from "./types";
import type { FormattedPost } from "@/lib/blog";

const getResultsLabel = (
  {
    searchTerm,
    slug,
    tagId,
  }: {
    searchTerm?: string | null;
    slug?: string | null;
    tagId?: string | null;
  },
  tags: Tag[],
) => {
  if (tagId) {
    return tags.find(
      (tag) => tag.id?.toString() === tagId || tag.slug === tagId,
    )?.name;
  }

  if (slug) {
    return slug;
  }

  if (searchTerm) {
    return searchTerm;
  }

  return undefined;
};

const BlogContent = ({
  posts,
  tags,
  initialTag,
  page,
  totalPages,
}: BlogContentProps) => {
  const searchParams = useSearchParams();

  const searchTerm = searchParams.get("search");
  const slug = searchParams.get("slug") ?? initialTag?.slug ?? undefined;
  const tagId =
    searchParams.get("tags") ?? initialTag?.id?.toString() ?? undefined;

  const resultsFor = getResultsLabel(
    { searchTerm: searchTerm?.trim(), slug, tagId },
    tags,
  );

  if (!posts.length) {
    return (
      <section className={styles.Blog}>
        <div className="container">
          <SearchBar tags={tags} />
          {resultsFor && <ResultsFor>{resultsFor}</ResultsFor>}
          <ErrorMessage content="No blog posts matched your filters." />
        </div>
      </section>
    );
  }

  return (
    <section className={styles.Blog}>
      <div className="container">
        <SearchBar tags={tags} />
        {resultsFor && <ResultsFor>{resultsFor}</ResultsFor>}
        <Posts posts={posts} />
        <Pagination currentPage={page} totalPages={totalPages} />
        <KinervaContact
          block={{
            embedCode: `<script src="https://js-eu1.hsforms.net/forms/embed/147703054.js" defer></script><div class="hs-form-frame" data-region="eu1" data-form-id="75703026-1b75-4a0b-a26f-4600d7782d54" data-portal-id="147703054"></div>`,
          }}
        />
      </div>
    </section>
  );
};

interface BlogContentProps {
  posts: FormattedPost[];
  tags: Tag[];
  initialTag?: Tag;
  page: number;
  totalPages: number;
}

export default BlogContent;
